import { nanoid } from '@reduxjs/toolkit'
import React, { ComponentPropsWithoutRef } from 'react'
import styled from 'styled-components'
import { object } from 'yup'

interface IBasicInput extends ComponentPropsWithoutRef<'select'> {
  tag?: string
  options: { id: number; value: number | string; text: string }[]
  value: any
  isPrimary?: boolean
}
const BasicSelect = ({ tag, isPrimary = false, options, value, ...props }: IBasicInput) => {
  return (
    <InfoInput>
      {tag && (
        <span>
          {isPrimary ? <span className="text-[#583EEE]">* </span> : null}
          {tag}
        </span>
      )}
      <select
        {...props}
        value={value}
        style={{
          color: value === 'NO_VALUE' ? '#cccccc' : 'inherit',
        }}
      >
        {options.map((option) => (
          <option
            value={option.value}
            key={nanoid()}
            disabled={option.value === 'NO_VALUE'}
            selected={option.value === 'NO_VALUE'}
          >
            {option.text}
          </option>
        ))}
      </select>
    </InfoInput>
  )
}
const InfoInput = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  > span {
    ${({ theme }) => theme.wev_font.Regular_16};
    color: ${({ theme }) => theme.wev_color.text};
    margin-bottom: 10px;
  }
  > select {
    display: flex;
    align-items: center;
    height: 59px;
    width: 100%;
    ${({ theme }) => theme.wev_font.Regular_16};
    outline: none;
    border-radius: 10px;
    border: 1px solid ${({ theme }) => theme.wev_color.outline};
    padding: 0px 20px;
    > option {
      color: ${({ theme }) => theme.wev_color.text};
    }
    :focus {
      box-shadow: none;
    }
  }
`
export default BasicSelect
